export default function templatePreviewLoader($injector, templateId) {
    const blob = $injector.get('Blob');
    return $injector.get('$http').get(`templates/${templateId}/preview`, {responseType: 'blob'})
        .then(({data, headers}) => {
            const responseBlob = new blob([data], {type: headers('content-type')});

            return window.URL.createObjectURL(responseBlob);
        })
        .catch((response) => {
            return response;
        })
}



// WEBPACK FOOTER //
// ./src/app/modules/templates/helpers/template-preview-loader.js